// src/ErrorBoundary.js
import React from "react";

export default class ChunkErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    // detect Webpack chunk-loading failures
    if (error?.name === "ChunkLoadError") {
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error, info) {
    console.error("Chunk load failed, reloading page...", error);
  }

  render() {
    if (this.state.hasError) {
      // force a full reload so the browser fetches the new chunks
      window.location.reload();
      return null; // nothing to render while reloading
    }
    return this.props.children;
  }
}
